// Override mobile facets to use dropdown instead of sliding panels
(function() {
  'use strict';
  
  // Only run on mobile screens
  function isMobile() {
    return window.innerWidth <= 749;
  }
  
  // Store which details elements are open
  let openDetailsIds = new Set();
  
  // Save the state of open details before form submission
  function saveOpenDetailsState() {
    openDetailsIds.clear();
    const mobileFacetsWrapper = document.querySelector('.mobile-facets__wrapper');
    if (!mobileFacetsWrapper) return;
    
    const openDetails = mobileFacetsWrapper.querySelectorAll('.mobile-facets__details[open]');
    openDetails.forEach(details => {
      if (details.id) {
        openDetailsIds.add(details.id);
      }
    });
  }
  
  // Restore the state of open details after form submission
  function restoreOpenDetailsState() {
    setTimeout(() => {
      openDetailsIds.forEach(id => {
        const details = document.getElementById(id);
        if (details) {
          details.setAttribute('open', '');
        }
      });
    }, 100);
  }
  
  // Auto-submit form when filter is changed
  function setupAutoSubmit() {
    const mobileFacetsForm = document.querySelector('#FacetFiltersFormMobile');
    if (!mobileFacetsForm) return;
    
    // Listen for checkbox changes
    const checkboxes = mobileFacetsForm.querySelectorAll('.mobile-facets__checkbox');
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        // Save which details are currently open
        saveOpenDetailsState();
        
        // Trigger form submission
        const form = this.closest('form');
        if (form) {
          // Use the existing facets.js form submission
          const event = new Event('input', { bubbles: true });
          form.dispatchEvent(event);
          
          // Restore open state after the form updates
          restoreOpenDetailsState();
        }
      });
    });
    
    // Listen for price range changes
    const priceInputs = mobileFacetsForm.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]');
    priceInputs.forEach(input => {
      input.addEventListener('change', function() {
        saveOpenDetailsState();
        
        const form = this.closest('form');
        if (form) {
          const event = new Event('input', { bubbles: true });
          form.dispatchEvent(event);
          
          restoreOpenDetailsState();
        }
      });
    });
  }
  
  // Override the MenuDrawer behavior for mobile facets
  function overrideMobileFacets() {
    if (!isMobile()) return;
    
    const mobileFacetsWrapper = document.querySelector('.mobile-facets__wrapper');
    if (!mobileFacetsWrapper) return;
    
    const filterDetails = mobileFacetsWrapper.querySelectorAll('.mobile-facets__details');
    
    filterDetails.forEach(details => {
      const summary = details.querySelector('.mobile-facets__summary');
      if (!summary) return;
      
      // Prevent the default MenuDrawer behavior
      summary.addEventListener('click', function(e) {
        // Don't prevent default - let the details element handle it naturally
        // Just prevent the parent menu from being hidden
        
        setTimeout(() => {
          // Remove submenu-open class that hides parent elements
          const submenuOpens = mobileFacetsWrapper.querySelectorAll('.submenu-open');
          submenuOpens.forEach(element => {
            if (isMobile()) {
              element.classList.remove('submenu-open');
            }
          });
        }, 0);
      });
    });
    
    // Setup auto-submit functionality
    setupAutoSubmit();
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', overrideMobileFacets);
  } else {
    overrideMobileFacets();
  }
  
  // Re-run after facet filtering (when content is replaced)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && isMobile()) {
        const mobileFacetsWrapper = document.querySelector('.mobile-facets__wrapper');
        if (mobileFacetsWrapper && mutation.target.contains(mobileFacetsWrapper)) {
          overrideMobileFacets();
        }
      }
    });
  });
  
  // Start observing
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
})();
